module.exports = __webpack_public_path__ + "static/media/pic3@3x.416bfd32.png";